import apiSlice from "./apiSlice";

export interface RunnerItem {
    handicap: number;
    runnerName: string;
    selectionId: string;
    sortPriority: string;
    runnerId: string;
}

export interface MarketRunners {
    id: string;
    externalId: string;
    eventId: string;
    status: string;
    runner: RunnerItem[];
}

export interface MarketRunnerResponse {
    success: boolean;
    message: string;
    marketRunners: MarketRunners;
}

export const eventApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMarketRunner: builder.query<MarketRunnerResponse, { eventId: string | number; marketId: string }>(
            {
                query: ({ eventId, marketId }) => ({
                    url: `/market/runner/${eventId}/${marketId}`,
                    method: "GET",
                    params: { t: Date.now() }
                }),
            }
        )
    }),
});

export const { useGetMarketRunnerQuery, useLazyGetMarketRunnerQuery } = eventApi;
